/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          : DisplayProductCardMSA.tsx
*
* Project Title : Checkout
*
* Description   : Initial version
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : Deepthi B (E844276)
*
* @Date         : Oct 10, 2019
*
* @Version      : Version 1.0
*
*
*
* By           : Deepthi Bachu (E844276)
* On           : Oct 17, 2019
* Description  : Updated code as per ASDS-1583
 *
 * By            : H224423
 * On            : Dec 3, 2019
 * Description   : ASDS-1995 - UI Issue Fixes.
 *
 * By            : H224423
 * On            : Mar 12 2020
 * Description   : ASDS-2083 - APU MSA UI changes
 *
 * By            : H422335
 * On            : Sep 24 2020
 * Description   : ASDS-3045 - APU Phase 2 UI Enhancements
 *
 * By             : H422336
 * On             : Oct 06,2020
 * Description    : ASDS-3227 APU enhancements as part of phase-2
 *
 ******************************************************************************/
import * as React from 'react';
import { Grid, Icon, Card } from '@scuf/common';
import { DataTable } from '@scuf/datatable';
import '@scuf/common/honeywell/theme.css';
import './ConfigureAPU.css';
import { ICellData } from '@scuf/datatable/dist/components/DataTable/IDataTableInterfaces';

function unitPriceRenderer(cellData: ICellData) {
    return <span>{`$${cellData.value.toFixed(2)}`}</span>;
}

function DisplayProductCardMSA(props: any) {
    return (
        <Card className="fullwidthCard config-confirmation-card-spacing">
            <Card.Content>
                <Grid>
                    <Grid.Row className="dispayProductCardMSA">
                        <Grid.Column width={11} className="fullwidthRow">
                        <span className="ca-serial-title-text">APU MSA Contract Number &amp; Serial Number</span>
                        </Grid.Column>
                        <Grid.Column width={1} className="fullwidthRow">
                            <div className="pull-right">
                            <Icon
                                root="common"
                                name="edit"
                                size="small"
                                className="confirmation-edit-icon"
                                onClick={props.gotoProductConfigureTab}
                            />
                                </div>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width={12} className="fullwidthRow prod-congfig-confirm-table">
                            <DataTable
                                data={props.productConfigData}
                                scrollable={true}
                                scrollHeight="150px"
                                virtualRowHeight={48}
                                resizableColumns={true}
                            >
                                <DataTable.Column field="soldTo" header="Sold To No." align="left" editable={false}/>
                                <DataTable.Column field="contractNo" header="Contract No." align="left" editable={false}/>
                                <DataTable.Column field="expirationDate" header="Expiration Date" align="left" editable={false}/>
                                <DataTable.Column field="aircraftOem" header="APU Model No." align="left" editable={false}/>
                                <DataTable.Column field="serialNumber" header="APU Serial No." align="left" editable={false}/>
                                <DataTable.Column field="unitPrice" header="Unit Price" align="left" renderer={unitPriceRenderer} editable={false}/>
                            </DataTable>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Card.Content>
        </Card>
    );
}

export default DisplayProductCardMSA;